import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-card', {
    staticClass: "shadow-sm"
  }, [_c('b-card-body', {
    staticClass: "mb-4 px-6 pt-6"
  }, [_vm.loading ? _c('div', [_c('b-row', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "col-6 border-right"
  }, [_c('b-skeleton', {
    staticClass: "mx-auto mb-3",
    attrs: {
      "width": "60%",
      "height": "18px"
    }
  }), _c('b-skeleton', {
    staticClass: "mx-auto",
    attrs: {
      "width": "70%",
      "height": "48px"
    }
  })], 1), _c('div', {
    staticClass: "col-6"
  }, [_c('b-skeleton', {
    staticClass: "mx-auto mb-3",
    attrs: {
      "width": "60%",
      "height": "18px"
    }
  }), _c('b-skeleton', {
    staticClass: "mx-auto",
    attrs: {
      "width": "70%",
      "height": "48px"
    }
  })], 1)])], 1) : _c('div', [_c('b-row', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "col-6 border-right",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'pessoasLista'
        });
      }
    }
  }, [_c('b-card-title', {
    staticClass: "mb-5"
  }, [_c('b-icon', {
    staticClass: "mr-2",
    attrs: {
      "icon": "people-fill",
      "variant": "primary"
    }
  }), _vm._v(" Pessoas ")], 1), _c('h2', {
    staticClass: "display-4 text-primary mb-0 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.pessoas) + " ")])], 1), _c('div', {
    staticClass: "col-6",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'produtosLista'
        });
      }
    }
  }, [_c('b-card-title', {
    staticClass: "mb-5 totalizador-produtos-title",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('b-icon', {
    staticClass: "mr-2",
    attrs: {
      "icon": "tags-fill",
      "variant": "primary"
    }
  }), _c('b-dropdown', {
    attrs: {
      "variant": "link",
      "toggle-class": "p-0 text-secondary font-weight-bold dashboard-title-dropdown",
      "menu-class": "dashboard-title-menu",
      "no-caret": ""
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function fn() {
        return [_c('span', {
          staticClass: "dashboard-title-label",
          class: {
            'dashboard-title-label-sm': _vm.produtoSelecionado === 'produtos_estoque'
          }
        }, [_vm._v(" " + _vm._s(_vm.produtoSelecionadoLabel) + " ")]), _c('b-icon', {
          staticClass: "dashboard-title-icon",
          attrs: {
            "icon": "chevron-down"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('b-dropdown-item', {
    attrs: {
      "active": _vm.produtoSelecionado === 'produtos'
    },
    on: {
      "click": function click($event) {
        _vm.produtoSelecionado = 'produtos';
      }
    }
  }, [_vm._v(" Produtos ")]), _c('b-dropdown-item', {
    attrs: {
      "active": _vm.produtoSelecionado === 'produtos_estoque'
    },
    on: {
      "click": function click($event) {
        _vm.produtoSelecionado = 'produtos_estoque';
      }
    }
  }, [_vm._v(" Produtos em Estoque ")])], 1)], 1), _c('h2', {
    staticClass: "display-4 text-primary mb-0 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.produtos) + " ")])], 1)])], 1)])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };